import React, {Component} from "react";
import PackageContextProvider from "./context/PackageContext";
import PackageList from "./PackageList";
import CapabilityContextProvider from "../global/context/ConfigContext";

class Package extends Component {
    render() {
        return (
            <CapabilityContextProvider>
            <PackageContextProvider>
                <PackageList packageList = {this.props.match.params}/>
            </PackageContextProvider>
            </CapabilityContextProvider>
        )
    }
}

export default Package


// WEBPACK FOOTER //
// ./src/components/package/Package.js